import { render, staticRenderFns } from "./AnswersEditBlockHeader.vue?vue&type=template&id=25edcc0c&scoped=true"
import script from "./AnswersEditBlockHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./AnswersEditBlockHeader.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AnswersEditBlockHeader.vue?vue&type=style&index=0&id=25edcc0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25edcc0c",
  null
  
)

export default component.exports